import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PackageProvider } from './context/PackageContext';
import Home from './pages/Home';
import Admin from './pages/Admin';
import TripDetails from './pages/TripDetails';
import FloatingQuickActions from './components/FloatingQuickActions';
import './styles/App.css';

const AppContent = () => {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/trip-details/:tripId" element={<TripDetails />} />
      </Routes>
      <FloatingQuickActions />
    </div>
  );
};

function App() {
  return (
    <PackageProvider>
      <Router>
        <AppContent />
      </Router>
    </PackageProvider>
  );
}

export default App;
